export { default } from "./SwiperBanner"
